// MuestraArchivosCellLite.jsx
import React, { useEffect, useState } from "react";
import { Box, Skeleton } from "@mui/material";
import FileThumbnails from "../Estimates/FileThumbnails";

import { fetchMuestraFilesCached } from "../../utils/muestraFilesRequest";
import { hasCachedArchivos, getCachedArchivos } from "../../utils/cacheArchivos";
import { filterMuestraGeneralFiles } from "../../utils/muestraFileCategories";

const MuestraArchivosCellLite = ({ muestraId }) => {
  const [files, setFiles] = useState(null);

  useEffect(() => {
    if (!muestraId) {
      setFiles([]);
      return;
    }

    if (hasCachedArchivos(muestraId)) {
      const cached = getCachedArchivos(muestraId);
      setFiles(
        Array.isArray(cached)
          ? filterMuestraGeneralFiles(cached).slice(0, 4)
          : [],
      );
      return;
    }

    let cancelled = false;

    fetchMuestraFilesCached(muestraId).then((filesData) => {
      if (!cancelled) {
        setFiles(filterMuestraGeneralFiles(filesData).slice(0, 4));
      }
    });

    return () => {
      cancelled = true;
    };
  }, [muestraId]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        gap: "0.4em",
        height: "100%",
        alignItems: "center",
      }}
    >
      {files === null &&
        [1, 2, 3].map((i) => (
          <Skeleton
            key={i}
            variant="rectangular"
            width={70}
            height={120}
            sx={{ borderRadius: 2 }}
          />
        ))}

      {files &&
        files.map((file, idx) => (
          <FileThumbnails key={idx} filePath={file.path} />
        ))}
    </Box>
  );
};

export default MuestraArchivosCellLite;
